import { useEffect, useState } from 'react';
import { useScrollToBottom } from './useScrollToBottom';

export function useMessages({
  chatId,
  status,
}: {
  chatId: string;
  status: 'ready' | 'streaming' | 'submitted' | undefined;
}) {
  const {
    containerRef,
    endRef,
    isAtBottom,
    scrollToBottom,
    onViewportEnter,
    onViewportLeave,
  } = useScrollToBottom();

  const [hasSentMessage, setHasSentMessage] = useState<boolean>(false);

  // Scroll to bottom instantly when chat changes
  useEffect(() => {
    if (chatId) {
      scrollToBottom('instant');
      setHasSentMessage(false);
    }
  }, [chatId, scrollToBottom]);

  // Track when user sends a message - now enabled for auto-prompts with throttled padding
  useEffect(() => {
    if (status === 'submitted') {
      setHasSentMessage(true);
    }
  }, [status]);

  return {
    containerRef,
    endRef,
    isAtBottom,
    scrollToBottom,
    onViewportEnter,
    onViewportLeave,
    hasSentMessage,
  };
}
